var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Url = require('url'); // cxRes


var libPath = require("path"); //const path   = require("path");


var _require = require('cross-fetch'),
    Response = _require.Response;

var contentTypeLookup = require('mime-types').contentType;

var SolidRest = /*#__PURE__*/function () {
  "use strict";

  function SolidRest(handlers) {
    var _this = this;

    _classCallCheck(this, SolidRest);

    this.storageHandlers = {};
    handlers.forEach(function (handler) {
      console.log("\n       Installing Rest Handler ".concat(handler.name, " using prefix ").concat(handler.prefix, "\n     "));
      _this.storageHandlers[handler.prefix] = handler;
    });
  }

  _createClass(SolidRest, [{
    key: "storage",
    value: function storage(options) {
      var prefix = typeof options === "string" ? options : options.rest_prefix;
      if (!this.storageHandlers[prefix]) throw "Did not recognize prefix " + prefix;
      return this.storageHandlers[prefix];
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(uri) {
        var options,
            self,
            url,
            pathname,
            path,
            _ref,
            _ref2,
            objectType,
            objectExists,
            notFoundMessage,
            resOptions,
            contents,
            _ref3,
            _ref4,
            status,
            turtleContents,
            headers,
            _ref5,
            _ref6,
            _status,
            _contents,
            _headers,
            _ref7,
            _ref8,
            _status2,
            _headers2,
            _ref9,
            _ref10,
            _status3,
            _headers3,
            link,
            slug,
            _ref11,
            _ref12,
            _status4,
            _headers4,
            _ref13,
            _ref14,
            _status5,
            _headers5,
            _ref15,
            _ref16,
            _status6,
            _undefined,
            _headers6,
            _ref17,
            _ref18,
            putStatus,
            putHeaders,
            _response,
            _container2turtle,
            _container2turtle2,
            _getExtension,
            _getContentType,
            _getHeaders,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getHeaders = function _ref26(pathname, options) {
                  // cxRes
                  var fn = path.basename(pathname); // let fn = encodeURI(pathname.replace(/.*\//,''))  

                  var headers = typeof self.storage(options).getHeaders != "undefined" ? self.storage(options).getHeaders(pathname, options) : {};
                  headers.location = headers.url = headers.location || options.url;
                  headers.date = headers.date || new Date(Date.now()).toISOString();
                  headers.allow = headers.allow || ['HEAD, GET, POST, PUT, DELETE']; //   [ 'OPTIONS, HEAD, GET, PATCH, POST, PUT, DELETE' ]

                  headers['wac-allow'] = headers['wac-allow'] || "user=\"read write append control\",public=\"read\"";
                  headers['x-powered-by'] = headers['x-powered-by'] || self.storage(options).name;
                  /*
                      const ext = ( path.basename(pathname).startsWith('.') )
                                ? path.basename(pathname)
                                : path.extname(pathname)
                  */

                  var ext = _getExtension(pathname);

                  headers['content-type'] = headers['content-type'] || _getContentType(ext, options.objectType);

                  if (!headers['content-type']) {
                    delete headers['content-type'];
                  }

                  headers.link = headers.link;

                  if (!headers.link) {
                    if (ext === '.acl') {
                      // TBD : IS THIS CORRECT? IS THE TYPE OF ACL "resource"?
                      headers.link = "<http://www.w3.org/ns/ldp#Resource>; rel=\"type\"";
                    } else if (ext === '.meta') {
                      headers.link = "<".concat(fn, ".acl>; rel=\"acl\",") + "<http://www.w3.org/ns/ldp#Resource>; rel=\"type\"";
                    } else if (options.objectType === 'Container') {
                      headers.link = "<.meta>; rel=\"describedBy\", <.acl>; rel=\"acl\"," + "<http://www.w3.org/ns/ldp#Container>; rel=\"type\"," + "<http://www.w3.org/ns/ldp#BasicContainer>; rel=\"type\"";
                    } else {
                      headers.link = "<".concat(fn, ".meta>; rel=\"describedBy\", <").concat(fn, ".acl>; rel=\"acl\",") + "<http://www.w3.org/ns/ldp#Resource>; rel=\"type\"";
                    }
                  }

                  return headers;
                  /*
                      headers.link = headers.link ||
                        options.objectType==="Container"
                          ? `<.meta>; rel="describedBy", <.acl>; rel="acl",`
                            +`<http://www.w3.org/ns/ldp#Container>; rel="type",`
                            +`<http://www.w3.org/ns/ldp#BasicContainer>; rel="type"`
                          : `<${fn}.meta>; rel="describedBy", <${fn}.acl>; rel="acl",`
                            +`<http://www.w3.org/ns/ldp#Resource>; rel="type"`
                  */
                };

                _getContentType = function _ref25(ext, type) {
                  if (!ext || ext === '.ttl' || ext === '.acl' || ext === '.meta' || type === "Container") {
                    return 'text/turtle';
                  } else {
                    return contentTypeLookup(ext);
                  }
                };

                _getExtension = function _ref24(pathname) {
                  var ext = path.basename(pathname).startsWith('.') ? path.basename(pathname) : path.extname(pathname);
                  return ext;
                };

                _container2turtle2 = function _ref23() {
                  _container2turtle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname, options, contentsArray) {
                    var filenames, str2, str, i, fn, _ref19, _ref20, ftype, e, ctype;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(typeof self.storage(options).container2turtle != "undefined")) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", self.storage(options).container2turtle(pathname, options, contentsArray));

                          case 2:
                            filenames = contentsArray.filter(function (item) {
                              if (!item.endsWith('.acl') && !item.endsWith('.meta')) {
                                return item;
                              }
                            }); // cxRes

                            if (!pathname.endsWith(path.sep)) pathname += path.sep; // if (!pathname.endsWith("/")) pathname += "/"

                            str2 = "";
                            str = "@prefix : <#>. @prefix ldp: <http://www.w3.org/ns/ldp#>.\n" + "<> a ldp:BasicContainer, ldp:Container";

                            if (!filenames.length) {
                              _context.next = 27;
                              break;
                            }

                            str = str + "; ldp:contains\n";
                            i = 0;

                          case 9:
                            if (!(i < filenames.length)) {
                              _context.next = 26;
                              break;
                            }

                            // let fn = filenames[i]
                            fn = encodeURI(filenames[i]);
                            _context.next = 13;
                            return self.storage(options).getObjectType(pathname + fn);

                          case 13:
                            _ref19 = _context.sent;
                            _ref20 = _slicedToArray(_ref19, 2);
                            ftype = _ref20[0];
                            e = _ref20[1];
                            if (ftype === "Container" && !fn.endsWith("/")) fn = fn + "/";
                            str = str + "  <".concat(fn, ">,\n");
                            ctype = _getContentType(_getExtension(fn), options.objectType);
                            ftype = ftype === "Container" ? "ldp:Container; a ldp:BasicContainer" : "ldp:Resource";
                            str2 = str2 + "<".concat(fn, "> a ").concat(ftype, ".\n");
                            str2 = str2 + "<".concat(fn, "> :type \"").concat(ctype, "\".\n");

                          case 23:
                            i++;
                            _context.next = 9;
                            break;

                          case 26:
                            str = str.replace(/,\n$/, "");

                          case 27:
                            str = str + ".\n" + str2; // str = _makeStream(str);

                            return _context.abrupt("return", [200, str]);

                          case 29:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return _container2turtle2.apply(this, arguments);
                };

                _container2turtle = function _ref22(_x2, _x3, _x4) {
                  return _container2turtle2.apply(this, arguments);
                };

                _response = function _ref21(body, options) {
                  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : options.status;
                  options.status = status;
                  options.headers = Object.assign(_getHeaders(pathname, options), options.headers);
                  return new Response(body, options);
                };

                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                self = this;
                options = options || {}; // cxRes

                /*
                   options.url = decodeURIComponent(uri)
                
                   let pathname = decodeURIComponent(Url.parse(uri).pathname)
                   let scheme = Url.parse(uri).protocol
                   let prefix = scheme.match("file") 
                     ? 'file' 
                     : uri.replace(scheme+'//','').replace(/\/.*$/,'')
                   options.scheme = scheme
                   options.rest_prefix = prefix
                */

                /**/

                url = new URL(uri);
                options.scheme = url.protocol;

                if (options.scheme.startsWith('file')) {
                  options.url = Url.format(url);
                  pathname = Url.fileURLToPath(options.url);
                  options.rest_prefix = 'file';
                  path = libPath;
                } else {
                  options.url = decodeURIComponent(uri);
                  pathname = Url.parse(options.url).pathname;
                  options.rest_prefix = uri.replace(options.scheme + '//', '').replace(/\/.*$/, '');
                  path = libPath.posix;
                }
                /**/


                if (!self.storage) {
                  if (self.storageHandler) {
                    self.storage = function () {
                      return self.storageHandlers[prefix];
                    };
                  } else {
                    self = new SolidRest([new SolidBrowserFS()]);
                  }
                }

                options.method = (options.method || options.Method || 'GET').toUpperCase();
                options.headers = options.headers || {};
                _context2.next = 17;
                return self.storage(options).getObjectType(pathname, options);

              case 17:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                objectType = _ref2[0];
                objectExists = _ref2[1];
                options.objectType = objectType;
                options.objectExists = objectExists;
                notFoundMessage = '404 Not Found';
                if (objectType === "Container" && !options.url.endsWith('/')) options.url = "".concat(options.url, "/");
                resOptions = Object.assign({}, options);
                resOptions.headers = {};
                /* GET
                */

                if (!(options.method === 'GET')) {
                  _context2.next = 55;
                  break;
                }

                if (objectExists) {
                  _context2.next = 30;
                  break;
                }

                return _context2.abrupt("return", _response(notFoundMessage, resOptions, 404));

              case 30:
                if (!(objectType === "Container")) {
                  _context2.next = 45;
                  break;
                }

                _context2.next = 33;
                return self.storage(options).getContainer(pathname, options);

              case 33:
                contents = _context2.sent;
                _context2.next = 36;
                return _container2turtle(pathname, options, contents);

              case 36:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 3);
                status = _ref4[0];
                turtleContents = _ref4[1];
                headers = _ref4[2];
                Object.assign(resOptions.headers, headers);
                return _context2.abrupt("return", _response(turtleContents, resOptions, status));

              case 45:
                if (!(objectType === "Resource")) {
                  _context2.next = 55;
                  break;
                }

                _context2.next = 48;
                return self.storage(options).getResource(pathname, options);

              case 48:
                _ref5 = _context2.sent;
                _ref6 = _slicedToArray(_ref5, 3);
                _status = _ref6[0];
                _contents = _ref6[1];
                _headers = _ref6[2];
                Object.assign(resOptions.headers, _headers);
                return _context2.abrupt("return", _response(_contents, resOptions, _status));

              case 55:
                if (!(options.method === 'HEAD')) {
                  _context2.next = 61;
                  break;
                }

                if (objectExists) {
                  _context2.next = 60;
                  break;
                }

                return _context2.abrupt("return", _response(null, resOptions, 404));

              case 60:
                return _context2.abrupt("return", _response(null, resOptions, 200));

              case 61:
                if (!(options.method === "DELETE")) {
                  _context2.next = 86;
                  break;
                }

                if (objectExists) {
                  _context2.next = 64;
                  break;
                }

                return _context2.abrupt("return", _response(notFoundMessage, resOptions, 404));

              case 64:
                if (!(objectType === "Container")) {
                  _context2.next = 75;
                  break;
                }

                _context2.next = 67;
                return self.storage(options).deleteContainer(pathname, options);

              case 67:
                _ref7 = _context2.sent;
                _ref8 = _slicedToArray(_ref7, 3);
                _status2 = _ref8[0];
                _headers2 = _ref8[2];
                Object.assign(resOptions.headers, _headers2);
                return _context2.abrupt("return", _response(null, resOptions, _status2));

              case 75:
                if (!(objectType === 'Resource')) {
                  _context2.next = 86;
                  break;
                }

                _context2.next = 78;
                return self.storage(options).deleteResource(pathname, options);

              case 78:
                _ref9 = _context2.sent;
                _ref10 = _slicedToArray(_ref9, 3);
                _status3 = _ref10[0];
                _headers3 = _ref10[2];
                Object.assign(resOptions.headers, _headers3);
                return _context2.abrupt("return", _response(null, resOptions, _status3));

              case 86:
                if (!(options.method === "POST")) {
                  _context2.next = 115;
                  break;
                }

                if (objectExists) {
                  _context2.next = 89;
                  break;
                }

                return _context2.abrupt("return", _response(notFoundMessage, resOptions, 404));

              case 89:
                link = options.headers.Link || options.headers.link;
                slug = options.headers.Slug || options.headers.slug || options.slug;

                if (!slug.match(/\//)) {
                  _context2.next = 93;
                  break;
                }

                return _context2.abrupt("return", _response(null, resOptions, 400));

              case 93:
                // Now returns 400 instead of 404
                pathname = path.join(pathname, slug);
                if (pathname.startsWith('\\')) pathname = pathname.replace(/\\/g, '/');

                if (!(link && link.match("Container"))) {
                  _context2.next = 106;
                  break;
                }

                _context2.next = 98;
                return self.storage(options).postContainer(pathname, options);

              case 98:
                _ref11 = _context2.sent;
                _ref12 = _slicedToArray(_ref11, 3);
                _status4 = _ref12[0];
                _headers4 = _ref12[2];
                Object.assign(resOptions.headers, _headers4);
                return _context2.abrupt("return", _response(null, resOptions, _status4));

              case 106:
                if (!(link && link.match("Resource"))) {
                  _context2.next = 115;
                  break;
                }

                _context2.next = 109;
                return self.storage(options).putResource(pathname, options);

              case 109:
                _ref13 = _context2.sent;
                _ref14 = _slicedToArray(_ref13, 3);
                _status5 = _ref14[0];
                _headers5 = _ref14[2];
                Object.assign(resOptions.headers, _headers5);
                return _context2.abrupt("return", _response(null, resOptions, _status5));

              case 115:
                if (!(options.method === 'PUT')) {
                  _context2.next = 138;
                  break;
                }

                if (!(objectType === "Container")) {
                  _context2.next = 118;
                  break;
                }

                return _context2.abrupt("return", _response(null, resOptions, 409));

              case 118:
                _context2.next = 120;
                return self.storage(options).makeContainers(pathname, options);

              case 120:
                _ref15 = _context2.sent;
                _ref16 = _slicedToArray(_ref15, 3);
                _status6 = _ref16[0];
                _undefined = _ref16[1];
                _headers6 = _ref16[2];
                Object.assign(resOptions.headers, _headers6);

                if (!(_status6 !== 200 && _status6 !== 201)) {
                  _context2.next = 128;
                  break;
                }

                return _context2.abrupt("return", _response(null, resOptions, _status6));

              case 128:
                _context2.next = 130;
                return self.storage(options).putResource(pathname, options);

              case 130:
                _ref17 = _context2.sent;
                _ref18 = _slicedToArray(_ref17, 3);
                putStatus = _ref18[0];
                putHeaders = _ref18[2];
                Object.assign(resOptions.headers, putHeaders); // Note: The headers from makeContainers are also returned here

                return _context2.abrupt("return", _response(null, resOptions, putStatus));

              case 138:
                return _context2.abrupt("return", _response(null, resOptions, 405));

              case 139:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }() // end of fetch()

  }]);

  return SolidRest;
}(); // end of SolidRest()


module.exports = exports = SolidRest;
/* END */

/*
required
  getObjectType
  getResouce
  getContainer
  putResource
  postResource
  postContainer
  deleteResource
  deleteContainer
  makeContainers
optional
  getHeaders
  text
  json
*/